import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { ChangeEvent, Component } from 'react';

import Director from 'client/components/director';

import { DirectorCommittee, DirectorData, PageDirectorsProps, PageName } from 'client/bundles/types';

import './index.css';

import Select from 'client/components/lego/select';
import MenuSection from 'client/components/menu-section';

interface SelectOption {
    value: DirectorCommittee;
    content: string;
}

const b = cn('directors');
const bPageTitle = cn('page-title');

interface Props extends PageDirectorsProps {
    pageName: PageName;
}

class Directors extends Component<Props> {
    static contextType = LangContext;

    getSelectOptions = (): SelectOption[] => {
        const { committees } = this.props;
        const { lang, dictionary } = this.context;
        const committeeName = dictionary.committee;

        return Object.keys(committees).map(committeeType => {
            const committeeTypeData = committees[committeeType];
            const isLangEnglish = lang === 'en';
            let committeePhrase = isLangEnglish ? `${committeeTypeData} ${committeeName}` : `${committeeName} ${committeeTypeData}`;

            if (committeeType === 'all') {
                committeePhrase = `${committeeTypeData} ${committeeName}${isLangEnglish ? 's' : 'ы'}`;
            }

            return {
                value: committeeType,
                content: committeePhrase
            };
        });
    }

    onSelectChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        const url = new URL(window.location.href);

        url.searchParams.set('committee', event.target.value);
        window.document.location.href = url.href;
    }

    renderList = () => {
        const { dictionary } = this.context;

        return (
            <div className={b('list')}>
                <div className={b('list-head')}>
                    <span className={b('person')}>{dictionary.committee_name}</span>
                    <span className={b('role')}>{dictionary.committee_title}</span>
                    <span className={b('committees')}>
                        <Select
                            size="m"
                            theme="normal"
                            className={b('select')}
                            value={this.props.selectedCommittee || 'all'}
                            options={this.getSelectOptions()}
                            onChange={this.onSelectChange}
                            />

                        <span className={b('committees-title')}>{dictionary.committee_membership}</span>
                    </span>
                    <div className={b('control')} />
                </div>
                <div className={b('list-content')}>
                    {
                        this.props.list.map((listItem: DirectorData, index) => {
                            return this.renderListItem(listItem, index);
                        })
                    }
                </div>
            </div>
        );
    }

    renderListItem = (director: DirectorData, index: number) => {
        const { committees } = this.props;

        return (
            <div className={b('list-item')} key={index}>
                <Director director={director} committees={committees} />
            </div>
        );
    }

    render() {
        const { title, pageName } = this.props;
        const { lang } = this.context;

        return (
            <div className={b()}>
                <h1 className={bPageTitle(lang === 'ru' ? { type: 'border' } : '')}>{title}</h1>

                {

                    /* TODO разобраться с подменю IR-571 */
                    lang === 'en' && <MenuSection type="governance" pageName={pageName} />
                }

                { this.renderList() }
            </div>
        );
    }

}

export default Directors;
